import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { AuthenticationService } from '@flexyoo/auth';
import { WhiteLabelService } from '@flexyoo/common';
import { LangService } from '@flexyoo/shared/services';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageEnum } from 'src/app/shared/models/constants';
import { RoleEnum } from 'src/app/shared/models/general/general-enum';
import { User } from 'src/app/shared/models/user-model';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  imports: [
    MatMenuModule,
    MatButtonModule,
    MatDivider,
    TranslateModule,
    MatButtonToggleModule,
    MatIcon,
    RouterModule,
  ],
})
export class UserMenuComponent {
  @Input({ required: true }) public user: User;

  private readonly auth = inject(AuthenticationService);
  private readonly langService = inject(LangService);
  protected wls = inject(WhiteLabelService);

  get activeLanguage() {
    return this.langService.lang;
  }

  protected onLoginAsEmployee(): void {
    this.auth.loginAsEmployee(this.user.TenantId);
  }

  protected onLoginAsHr(): void {
    this.auth.loginAsHr(this.user.EmployeeId);
  }

  protected changeLanguage(lang: LanguageEnum): void {
    this.langService.lang = lang;
  }

  protected openProductTourLink(): void {
    const lang = this.langService.lang === 'en' ? this.user.Language : this.langService.lang;
    const url = `https://demo.flexyoo.be/product_tour/${lang}/${
      this.user.Role === RoleEnum.HR ? 'create_employee' : 'employee_select'
    }/1.html`;
    window.open(url, '_blank');
  }

  protected onLogout(): void {
    this.auth.logout();
  }
}
